var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isUserRoleAssigned
    ? _c("NotFoundPage", {
        attrs: {
          "error-response": _vm.$t("noPermissions"),
          "button-is-visible": false,
        },
      })
    : _c(
        "div",
        { staticClass: "operational-table-view__wrapper" },
        [
          _c("p", { staticClass: "operational-table-view--heading" }, [
            _vm._v(" " + _vm._s(_vm.$t("operationalData.listTitle")) + " "),
          ]),
          _c("op-data-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLoading,
                expression: "!isLoading",
              },
            ],
          }),
          _vm.isLoading
            ? _c("pui-loader-spinner", {
                attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
              })
            : _vm._e(),
          _vm.pagination
            ? _c("pui-pagination", {
                staticClass: "operational-table-view__pagination",
                attrs: { "total-pages": _vm.pagination.TotalPages },
                on: { "changed:page": _vm.onPageChanged },
                model: {
                  value: _vm.pagination.CurrentPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "CurrentPage", $$v)
                  },
                  expression: "pagination.CurrentPage",
                },
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }